import { Card, CardHeader, Typography, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../app/slices/sectionSlice";
import SectionsForm from "../../form";
import { AiOutlineApartment } from "react-icons/ai";

const SectionHeader = () => {
  const _Section = useSelector((state) => state.section.section);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            الاقسام
          </Typography>
        }
        avatar={<AiOutlineApartment size={20} />}
        action={
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<IoIosAddCircleOutline />}
            onClick={() => dispatch(setDialog())}
          >
            إضافة قسم جديد
          </Button>
        }
      />
      {_Section.dialog ? <SectionsForm /> : null}
    </Card>
  );
};

export default SectionHeader;
